import React, { useState } from 'react'
import { Avatar, Button, Card, Checkbox, Table } from 'antd'
import moment from 'moment'
import _ from 'lodash'
import { PODType } from '../../../config'
import HeroPODView from '../../HeroPODView'

const HeroPOView = (props) => {
  const { visible, onCancel, formData } = props
  const [visiblePOD, setVisiblePOD] = useState(false)
  const [poDeliverId, setPoDeliverId] = useState(0)

  const columns = [
    {
      title: 'วันที่ส่ง',
      dataIndex: 'sendDate',
      key: 'sendDate',
      render: (date) => <span>{moment(date).format('DD/MM/YYYY')}</span>
    },
    {
      title: 'วัสดุที่ส่ง',
      render: () => <span>{formData.materialName}</span>
    },
    {
      title: 'ผู้ส่ง',
      key: 'heroName',
      dataIndex: 'heroDeliver.name',
      render: (heroName) => <span>{heroName}</span>
    },
    {
      title: 'ส่ง',
      key: 'amountSent',
      dataIndex: 'amountSent',
      render: (amountSent) => <span>{amountSent ? amountSent : ''}</span>
    },
    {
      title: 'รับ',
      key: 'amountReceive',
      dataIndex: 'amountReceive',
      render: (amountReceive) => <span>{amountReceive ? amountReceive : ''}</span>
    },
    {
      title: 'สถานะ',
      key: 'status',
      dataIndex: 'status',
      render: (status) => <span>{PODType[status] ? PODType[status].title : status}</span>
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="eye"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]

  const onClick = (e, record) => {
    e.preventDefault()
    setVisiblePOD(true)
    setPoDeliverId(record.id)
  }

  const onCloseModal = async () => {
    await setVisiblePOD(false)
    await setPoDeliverId(0)
  }


  return (
    <div>
      {(!visiblePOD) ?
        <Card
          destroyOnClose={true}
          title={'รายละเอียด PO'}
          visible={visible}
          extra={
            <div>
              <Button size="small" icon="close" onClick={() => onCancel()}>
                close
              </Button>
            </div>
          }>
          <strong>วันที่ส่ง: </strong> {formData.poStart ? moment(formData.poStart).format('DD/MM/YYYY') : ''} - {formData.poEnd ? moment(formData.poEnd).format('DD/MM/YYYY') : ''}<br />
          <strong>วันที่มีผล: </strong> {formData.datePriceStart ? moment(formData.datePriceStart).format('DD/MM/YYYY') : ''} - {formData.datePriceEnd ? moment(formData.datePriceEnd).format('DD/MM/YYYY') : ''}<br />
          <strong>วัสดุที่ส่ง: </strong>
          <span>
            <Avatar
              src={formData.materialImage}
              size={37}
              style={{ marginRight: 5 }}
            />
            {formData.materialName}
          </span><br />
          <strong>ราคารับซื้อ: </strong> {formData.price}<br />
          <strong>ผู้ประกาศ: </strong> {formData.heroName}<br />
          <strong>ยอดรับซื้อ: </strong> {formData.amount}  / {formData.quota} <br />
          <strong>สถานะ: </strong> {formData.status} <br />
          <strong>หลักฐานการส่งที่ต้องการ</strong><br />
          <Checkbox defaultChecked={formData.carPic} disabled /><strong> รูปรถพร้อมน้ำหนัก</strong><br />
          <Checkbox defaultChecked={formData.billPic} disabled /><strong> หลักฐานน้ำหนัก</strong>   <br />
          <strong>เอกสารที่โรงงานต้องการ</strong><br />
          {formData.documentRequire.length != 0 ?
            formData.documentRequire.map((doc) => <div><Checkbox defaultChecked disabled /><strong> {doc.name}</strong><br /></div>)
            : '-'
          }
          <div><br></br></div>
          <Card title="รายการส่งสินค้า">
            <Table
              bordered
              dataSource={formData.poDeliverList}
              columns={columns}
            />
          </Card>
        </Card>
        :
        <HeroPODView
          visible={visiblePOD}
          poDeliverId={poDeliverId}
          onCancel={onCloseModal}
        />}
    </div>
  )
}

export default HeroPOView
